import styled from 'styled-components'
import variables from '../../styles/variables'
import { TextWrapper } from '../../styles/base'
import { headerStyles } from '../../styles/global'
import { Heading } from '..'

export const Container = styled.div`
  padding-top: 80px;
`
export const ColorsSection = styled(TextWrapper)`
  ul {
    display: flex;
    flex-direction: row;

    li:not(:first-child) {
      margin-left: 20px;
    }
  }
`

export const SectionContainer = styled(TextWrapper)`
  padding: 20px 0 0 0;
  @media ${variables.media.sm} {
    padding: 60px 100px;
  }
  @media ${variables.media.md} {
    padding: 60px 50px 60px 150px;
  }
`

export const CarouselContainer = styled(SectionContainer)`
  @media ${variables.media.sm} {
    padding: 60px 100px 0 100px;
  }
  @media ${variables.media.md} {
    padding: 60px 50px 0 150px;
  }
`

export const SectionHeader = styled(Heading)`
  ${headerStyles.headerXSmall};
  color: ${variables.colors.oracle.dark};
  margin-left: 20px;
  margin-bottom: 0;

  @media ${variables.media.sm} {
    margin-left: 0;
  }
`

export const CarouselHeader = styled(SectionHeader)`
  text-align: center;
  margin-left: 0;
  margin-bottom: 30px;
  @media ${variables.media.md} {
    text-align: left;
    margin-bottom: 0;
  }
`

export const Centerer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
`

export const CallToActionContainer = styled(Centerer)`
  flex-direction: column;
`

export const SideSquareContainer = styled.div`
  position: relative;
  height: 0;
`
export const SquareContainer = styled(TextWrapper)`
  padding: 0 !important;

  @media ${variables.media.sm} {
    max-width: ${variables.maxContentWidth + 300}px;
  }
`

export const WhyAitoCenterer = styled(Centerer)`
  margin-top: 40px;
`
